export default {
  id: 'SalaryCalculator',
  code: 'CN',
  text: {
    'Total Salary:': '总工资:',
    'Total Salary': '当前工资',
    'The calculated salary will not be saved to our system, please export it after the calculation': '工资计算完成后请及时导出, 系统不会保存计算结果',
    'Calculate Salary': '计算工资',
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Fields/SalaryCalculator/locale.js